export default __webpack_public_path__ + "static/media/Youtube.0023c3ff.svg";